export default "/images/MatthiasMeseck.jpg?3dc598416cbf1517ff83ed082729532c";